import Search from '@library/Search/Search';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { faSearch, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';
import { toast } from 'react-toastify';

import { setAddress, setLocationCoordinates } from '@library/MaplibreMap/maplibre-map.slice';
import { isPointWithinMalawi } from '@library/MaplibreMap/maplibre-map.utils';
import { trackEvent } from '@services/analytics.service';
import { getSearchAutocompleteData, getSearchPlaceData } from '@services/data.service';

import './location-search.styl'

function LocationSearch({ map }) {
  const dispatch = useDispatch();
  const [showFullSearch, setShowFullSearch] = useState(false)

  const location = useLocation();
  const currentPage = location.pathname.split('/').pop();

  useEffect(() => {
    if (currentPage === 'create') {
      setShowFullSearch(true);
    }

    return () => {
      setShowFullSearch(false);
    }
  }, [currentPage])

  const SearchGoogleFunction = [
    {
      id: 'searchdata',
      name: 'google',
      onSearch: async (query) => {
        await new Promise((resolve) => { if (query.length >= 3) { resolve('Promise resolved') } })
        trackEvent('location_search');
        const results = getSearchAutocompleteData(query).then((data) => {
          return data.predictions.map(
            (place) => {
              return {
                id: place.place_id,
                label: place.description,
              }
            },
          );
        })
        return results
      },
      onItemSelect: (item) => {
        if (item !== null) {
          getSearchPlaceData(item.id).then(async (data) => {
            if (data.results) {
              const selectedLat = data.results[0].geometry.location.lat;
              const selectedLng = data.results[0].geometry.location.lng;
              const isWithinMalawi = await isPointWithinMalawi(selectedLat, selectedLng);

              if (!isWithinMalawi) {
                toast.error('Please choose a location in Malawi.');
                return;
              }

              const geometry = data.results[0].geometry.viewport;

              map.fitBounds([
                geometry.northeast.lng,
                geometry.northeast.lat,
                geometry.southwest.lng,
                geometry.southwest.lat,
              ]);

              if (currentPage === 'create') {
                dispatch(setLocationCoordinates({
                  lat: selectedLat,
                  lng: selectedLng,
                }));
                
                dispatch(setAddress(data.results[0].formatted_address));
              }
            }
          })
        }
      },
    },
  ];

  return (
    <div className={`location-search ${showFullSearch ? 'location-search--full' : ''}`}>
      {showFullSearch && (
        <div className="location-search__container">
          <Search dataSources={SearchGoogleFunction} />
        </div>
      )}
      <Button
        icon={showFullSearch ? faXmark : faSearch}
        color="white"
        css={{
          padding: showFullSearch ? '8px' : '6px',
          border: '1px solid grey',
          borderRadius: '6px',
        }}
        onClick={() => setShowFullSearch(prevState => !prevState)}
        iconSize="14px"
      />
    </div>
  )
}

export default LocationSearch;
